import axios from 'axios'
import { ADMIN_API_URL } from 'const'

const BASE_URL = `${ADMIN_API_URL}/auto_trim`

export const getPrompt = async () => {
  try {
    const { data } = await axios.get(`${BASE_URL}/prompt`)
    return data
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}

export const testAutoTrim = async (
  sourceId,
  {
    systemPromptOverride,
    thinkingBudget,
    thinkingBuckets,
    model,
    numCandidates,
    preset,
    minS,
    maxS,
    schemaDescriptionOverrides,
  } = {}
) => {
  try {
    const body = { source_id: sourceId }
    if (systemPromptOverride) body.system_prompt_override = systemPromptOverride
    if (thinkingBudget != null) body.thinking_budget = thinkingBudget
    if (thinkingBuckets) body.thinking_buckets = thinkingBuckets
    if (model) body.model = model
    if (numCandidates != null) body.num_candidates = numCandidates
    if (preset) body.preset = preset
    if (minS != null) body.min_s = minS
    if (maxS != null) body.max_s = maxS
    if (schemaDescriptionOverrides)
      body.schema_description_overrides = schemaDescriptionOverrides
    const { data } = await axios.post(`${BASE_URL}/test`, body)
    return data
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}
